import { Injectable } from '@angular/core'
import {
  ActionToEventMapping,
  CmsService,
  createFrom,
  EventService,
  UserIdService
} from '@spartacus/core'
import {
  WishlistAddEntryEvent,
  WishlistAddEntryFailEvent,
  WishlistAddEntrySuccessEvent,
  WishlistRemoveEntryFailEvent,
  WishlistRemoveEntrySuccessEvent
} from './wishlist.events'
import { ActionsSubject, select, Store } from '@ngrx/store'
import { ofType } from '@ngrx/effects'
import { filter, map, withLatestFrom } from 'rxjs/operators'
import { Router } from '@angular/router'
import { EntityAction } from '../../state/utils/entity/entity.action'
import { CartActions, MultiCartSelectors, StateWithMultiCart } from '@spartacus/cart/base/core'
import { CartType } from '../../models'

@Injectable({
  providedIn: 'root'
})
export class MbWishlistEventBuilder {

  constructor (protected actionsSubject: ActionsSubject,
              protected eventService: EventService,
              protected store: Store<StateWithMultiCart>,
              protected userIdService: UserIdService,
              protected router: Router,
              protected cmsService: CmsService) {
    this.register()
  }

  protected register () {
    this.registerAddEntry()
  }

  protected registerAddEntry () {
    this.registerMapped({
      action: CartActions.CART_ADD_ENTRY,
      event: WishlistAddEntryEvent,
    })
    this.registerMapped({
      action: CartActions.CART_ADD_ENTRY_SUCCESS,
      event: WishlistAddEntrySuccessEvent,
    })
    this.registerMapped({
      action: CartActions.CART_ADD_ENTRY_FAIL,
      event: WishlistAddEntryFailEvent,
    })
  }

  protected registerRemoveEntry () {
    this.registerMapped({
      action: CartActions.CART_REMOVE_ENTRY_SUCCESS,
      event: WishlistRemoveEntrySuccessEvent,
    })
    this.registerMapped({
      action: CartActions.CART_REMOVE_ENTRY_FAIL,
      event: WishlistRemoveEntryFailEvent,
    })
  }

  protected registerMapped<T> (mapping: ActionToEventMapping<T>) {
    const eventStream$ = this.getAction(mapping.action).pipe(
      withLatestFrom(this.getWishListId(), this.cmsService.getCurrentPage()),
      filter(([action, wishlistId]) => action.payload['cartId'] === wishlistId),
      map(([action, wishlistId, page]) => createFrom(mapping.event as any, {
        ...action.payload,
        cartCode: wishlistId,
        entry: action.payload.entry,
        url: this.router.url,
        page
      }))
    )
    return this.eventService.register(mapping.event as any, eventStream$)
  }

  protected getAction (actionType: string | string[]) {
    return this.actionsSubject.pipe(
      ofType(...([] as string[]).concat(actionType)),
      map(v => v as EntityAction)
    )
  }

  protected getWishListId () {
    return this.store.pipe(select(MultiCartSelectors.getCartIdByTypeFactory(CartType.WISH_LIST)))
  }
}
